<!-- Seu componente Angular onde você está usando o Highcharts -->
<div class="w-[100%] h-2/3">
    <highcharts-chart
      [Highcharts]="Highcharts"
      [options]="chartOptions"
      class="w-full h-2/6 display: block;">
    </highcharts-chart>
  </div>
  